var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreateListingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 110,
    height: 110,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_10",
    "data-name": "Layer 10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m56 27.556-24-19.556-24 19.556v28.444h48z",
    fill: "#c8cded",
    "data-original": "#c8cded"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8 27.556v22.444h42a2 2 0 0 0 2-2v-23.7l-20-16.3z",
    fill: "#e2e7f6",
    "data-original": "#e2e7f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.108 25.625h16.881v2h-16.881z",
    fill: "#474747",
    transform: "matrix(.646 -.763 .763 .646 -11.28 28.924)",
    "data-original": "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.599 18.587h2v16.425h-2z",
    fill: "#474747",
    transform: "matrix(.763 -.646 .646 .763 -8.178 31.273)",
    "data-original": "#474747"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#b52f28",
    height: 18,
    rx: 3,
    width: 34,
    x: 15,
    y: 32,
    "data-original": "#b52f28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46 32h-28a3 3 0 0 0 -3 3v12h31z",
    fill: "#d23f34",
    "data-original": "#d23f34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56 21.2v-12.2h-8v5.8z",
    fill: "#3b5892",
    "data-original": "#3b5892"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62 26-3 4-27-22-27 22-3-4 30-24z",
    fill: "#4c6cb5",
    "data-original": "#4c6cb5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2 56h60v6h-60z",
    fill: "#3b5892",
    "data-original": "#3b5892"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59 58v-2h-57v3h56a1 1 0 0 0 1-1z",
    fill: "#4c6cb5",
    "data-original": "#4c6cb5"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#f2f2f2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m23 35h-4a1 1 0 0 0 -1 1v5a1 1 0 0 0 1 1h3v3h-2v-2h-2v3a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-5a1 1 0 0 0 -1-1h-3v-3h2v2h2v-3a1 1 0 0 0 -1-1z",
    fill: "#f2f2f2",
    "data-original": "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.98 35.8a1 1 0 0 0 -.98-.8h-3a1 1 0 0 0 -.98.8l-1 5a.925.925 0 0 0 -.02.2v6h2v-5h3v5h2v-6a.925.925 0 0 0 -.02-.2zm-1.8 1.2.6 3h-2.56l.6-3z",
    fill: "#f2f2f2",
    "data-original": "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35 35h-2v11a1 1 0 0 0 1 1h5v-2h-4z",
    fill: "#f2f2f2",
    "data-original": "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46 37v-2h-5a1 1 0 0 0 -1 1v10a1 1 0 0 0 1 1h5v-2h-4v-3h4v-2h-4v-3z",
    fill: "#f2f2f2",
    "data-original": "#f2f2f2"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 19,
    fill: "#f4a93c",
    r: 3,
    "data-original": "#f4a93c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29 19a2.965 2.965 0 0 0 .446 1.554 2.965 2.965 0 0 0 1.554.446 3 3 0 0 0 3-3 2.965 2.965 0 0 0 -.446-1.554 2.965 2.965 0 0 0 -1.554-.446 3 3 0 0 0 -3 3z",
    fill: "#f6b940",
    "data-original": "#f6b940"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateListingIcon);
export default __webpack_public_path__ + "static/media/create-listing-icon.3eac8733.svg";
export { ForwardRef as ReactComponent };